export default __webpack_public_path__ + "static/media/familia-motocarro.46f209e5.svg";